export enum Direction {
  NONE = 0,
  UP = 1,
  DOWN = 2,
  LEFT = 3,
  RIGHT = 4,
}

export enum Phase {
  MENU = 'MENU',
  PLAYING = 'PLAYING',
  VICTORY = 'VICTORY',
  DEFEAT = 'DEFEAT',
}

export interface GridCell {
  row: number;
  col: number;
}

export interface MazeConfig {
  width: number;
  height: number;
  cellSize: number;
}

/** Wall bitflags — each cell stores a bitmask of its walls */
export const Wall = {
  NORTH: 1,
  EAST: 2,
  SOUTH: 4,
  WEST: 8,
} as const;

export type WallFlag = typeof Wall[keyof typeof Wall];

/** Map Direction to the wall bitflag it crosses */
export const DIRECTION_TO_WALL: Record<Direction, number> = {
  [Direction.NONE]: 0,
  [Direction.UP]: Wall.NORTH,
  [Direction.DOWN]: Wall.SOUTH,
  [Direction.LEFT]: Wall.WEST,
  [Direction.RIGHT]: Wall.EAST,
};

/** Map Direction to the opposite wall (on the neighbor cell) */
export const OPPOSITE_WALL: Record<number, number> = {
  [Wall.NORTH]: Wall.SOUTH,
  [Wall.EAST]: Wall.WEST,
  [Wall.SOUTH]: Wall.NORTH,
  [Wall.WEST]: Wall.EAST,
};

/** Map Direction to row/col delta */
export const DIRECTION_DELTA: Record<Direction, GridCell> = {
  [Direction.NONE]: { row: 0, col: 0 },
  [Direction.UP]: { row: -1, col: 0 },
  [Direction.DOWN]: { row: 1, col: 0 },
  [Direction.LEFT]: { row: 0, col: -1 },
  [Direction.RIGHT]: { row: 0, col: 1 },
};
